import React, { useState, useEffect, useRef, Component } from "react";
import Breadcrumb from "../../component/breadcrumb/Breadcrumb";
import config from "../../config";
import { triggerNotification } from "../../component/message/Msg";
import { useNavigate, useParams } from "react-router-dom";
import Spinner from "../../component/loadingbar/Spinner";

const AddNotification = () => {
  const token = config.token;
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();

  // ---------------------------------------------- Manage State ----------------------------------------------------
  const [teachers, setTeachers] = useState([]);
  const [student, setStudent] = useState([]);
  const [course, setCourse] = useState([]);
  const [classnm, setClassnm] = useState([]);
  const [section, setSection] = useState([]);

  const [formData, setFormData] = useState({
    title: "",
    msg: "",
  });
  const [notificationFor, setNotificationFor] = useState("class");
  const [selectedClassnm, setSelectedClassnm] = useState("");
  const [selectedOption, setSelectedOption] = useState("");

  //handler state change
  const handleStateChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const NotificationForRadioChange = (event) => {
    setSelectedOption("");
    setSelectedClassnm("");
    setNotificationFor(event.target.id);
    console.log(event.target.id);
  };
  const handleSelectedClass = (e) => {
    setSelectedClassnm(e.target.value);
    // ----------------------------Fetch section list
    fetch(`${config.host_url}section/${e.target.value}`, {
      method: "POST",
      headers: {
        token: token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          //console.log(data.data);
          setSection(data.data);
        } else if (data.status === 401) {
          // Invalid token
          console.error("Invalid token");
        } else {
          // Handle other errors
          console.error("Internal server error");
        }
      })
      .catch((error) => {
        console.error("Error fetching section:", error);
      });
    console.log(e.target.value);
  };
  const handleSelectedNotificationForOption = (e) => {
    setSelectedOption(e.target.value);
    console.log(e.target.value);
  };

  //-------------------------------------- clear form data --------------------------------------r
  const clearForm = () => {
    setFormData({
      title: "",
      msg: "",
    });
    setSelectedClassnm("");
    setSelectedOption("");

    if (id) {
      navigate("/viewnotifications");
    }
  };

  // ---------------------------------------------- create / add Notification ----------------------------------------------------c
  // Function to create a new Notification
  const createNotification = async () => {
    try {
      if (!formData.title.trim() || !formData.msg.trim()) {
        triggerNotification("error", "Input fields cannot be empty!!");
        return;
      }
      if (notificationFor === "class" || notificationFor === "section") {
        if (
          selectedClassnm === "" ||
          selectedClassnm === "undefined" ||
          selectedClassnm === null
        ) {
          triggerNotification("error", "Input fields cannot be empty!!");
          return;
        }
      }
      if (
        notificationFor === "course" ||
        notificationFor === "section" ||
        notificationFor === "student" ||
        notificationFor === "teacher"
      ) {
        if (
          selectedOption === "" ||
          selectedOption === "undefined" ||
          selectedOption === null
        ) {
          triggerNotification("error", "Input fields cannot be empty!!");
          return;
        }
      }
      //notificationFor validation not require but for safety purpose
      if (notificationFor === "null") {
        triggerNotification("error", "Input fields cannot be empty!!");
        return;
      }

      fetch(
        `${config.host_url}notification/${
          id ? decodeURIComponent(atob(id)) : ""
        }`,
        {
          method: `${id ? "PUT" : "POST"}`,
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
          body: JSON.stringify({
            title: formData.title,
            msg: formData.msg,
            notification_for: notificationFor,
            ...(notificationFor === "section" && {
              classid: selectedClassnm,
              sectionid: selectedOption,
            }),
            ...(notificationFor === "class" && {
              classid: selectedClassnm,
            }),
            ...(notificationFor === "student" && {
              studentid: selectedOption,
            }),
            ...(notificationFor === "teacher" && {
              teacherid: selectedOption,
            }),
            ...(notificationFor === "course" && {
              courseid: selectedOption,
            }),
          }),
        }
      )
        .then((response) => response.json())
        .then((data) => {
          // console.log("data : ", data);
          if (data.status === 200) {
            // Notification created successfully
            triggerNotification(
              "success",
              `Notification ${id ? "updated" : "created"} successfully.`
            );
            navigate("/viewnotifications");
          } else if (data.status === 400) {
            // Handle validation errors
            triggerNotification("error", "Validation Error.");
          } else if (data.status === 401) {
            // Handle unauthorized (invalid token)
            triggerNotification("error", "Unauthenticated user");
          } else {
            // Handle other server errors
            triggerNotification("error", "Internal server error.");
          }
        })
        .catch((error) => {
          // Handle fetch error here
          triggerNotification("error", "Fetch error");
        });
    } catch (error) {
      console.error("Error creating Notification:", error);
      triggerNotification(
        "error",
        "An error occurred while creating the Notification."
      );
    }
  };

  //--------------------------------------- Fetch teacher, course, class, student ---------------------------------------
  useEffect(() => {
    if (localStorage.usertype !== "teacher") {
      // -----------------Fetch teacher list
      fetch(`${config.host_url}teacher`, {
        method: "GET",
        headers: {
          token: token,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            setTeachers(data.data);
            //console.log(data.data);
          } else if (data.status === 401) {
            // Invalid token
            console.error("Invalid token");
          } else {
            // Handle other errors
            console.error("Internal server error");
          }
        })
        .catch((error) => {
          console.error("Error fetching teacher:", error);
        });

      // -----------------------Fetch course list
      fetch(`${config.host_url}course`, {
        method: "GET",
        headers: {
          token: token,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            setCourse(data.data);
            //console.log(data.data);
          } else if (data.status === 401) {
            // Invalid token
            console.error("Invalid token");
          } else {
            // Handle other errors
            console.error("Internal server error");
          }
        })
        .catch((error) => {
          console.error("Error fetching course:", error);
        });
    }

    // ----------------------Fetch class list
    fetch(`${config.host_url}classes`, {
      method: "GET",
      headers: {
        token: token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          setClassnm(data.data);
          //console.log(data.data);
        } else if (data.status === 401) {
          // Invalid token
          console.error("Invalid token");
        } else {
          // Handle other errors
          console.error("Internal server error");
        }
      })
      .catch((error) => {
        console.error("Error fetching class:", error);
      });

    // --------------------------Fetch Student list
    fetch(`${config.host_url}student`, {
      method: "GET",
      headers: {
        token: token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          //console.log(data.data);
          setStudent(data.data);
        } else if (data.status === 401) {
          // Invalid token
          console.error("Invalid token");
        } else {
          // Handle other errors
          console.error("Internal server error");
        }
      })
      .catch((error) => {
        console.error("Error fetching Student:", error);
      });
  }, [token]);

  // useEffect(()=>{console.log(selectedClassnm);},[selectedClassnm])
  // --------------------------------------- set data for Edit form -----------------------------------
  const updateFieldValueSet = async (id) => {
    setLoading(true);
    try {
      await fetch(
        `${config.host_url}notification/${decodeURIComponent(atob(id))}`,
        {
          method: "GET",
          headers: {
            token: token,
          },
        }
      )
        .then((response) => response.json())
        .then(async (data) => {
          console.log(data.data);
          if (data.status === 200) {
            const responseData = data.data;
            console.log(responseData);
            await setFormData({
              title: responseData.title,
              msg: responseData.msg,
            });
            setNotificationFor(responseData.notification_for);
            setSelectedClassnm(responseData.classid);
            setSelectedOption(
              responseData.notification_for === "teacher"
                ? responseData.teacherid
                : responseData.notification_for === "student"
                ? responseData.studentid
                : responseData.notification_for === "course"
                ? responseData.courseid
                : responseData.notification_for === "section"
                ? responseData.sectionid
                : ""
            );
          }
        });
    } catch (error) {
      triggerNotification("error", "Error occurs in fetch data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id !== undefined) {
      updateFieldValueSet(id);
    }
  }, [id]);

  return (
    <>
      <Breadcrumb txt="Manage Notification" subpath={["Add Notification"]} />
      {/* form view */}
      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-header d-flex align-items-center ">
            <h5 className="mb-0">Add Notification</h5>
          </div>

          <div className="card-body">
            <form>
              {loading ? (
                <Spinner />
              ) : (
                <>
                  {/* Notification Title */}
                  <div className="form-floating form-floating-outline mb-4">
                    <input
                      type="text"
                      className="form-control"
                      name="title"
                      id="title"
                      placeholder="Notification Title"
                      value={formData.title}
                      onChange={handleStateChange}
                    />
                    <label htmlFor="title"> Notification Title</label>
                  </div>
                  {/* Notification Message */}
                  <div className="form-floating form-floating-outline mb-4">
                    <input
                      type="text"
                      className="form-control"
                      name="msg"
                      id="msg"
                      placeholder="Notification Message"
                      value={formData.msg}
                      onChange={handleStateChange}
                    />
                    <label htmlFor="msg"> Notification Message</label>
                  </div>

                  {/*Notification for*/}
                  <label className="form-check-label select-none ml-1">
                    Notification For
                  </label>
                  <div>
                    <div className="form-check form-check-inline ml-1">
                      <input
                        defaultChecked
                        name="form-check-group-image"
                        className="form-check-input"
                        type="radio"
                        value=""
                        checked={notificationFor === "class"}
                        id="class"
                        onChange={NotificationForRadioChange}
                      />
                      <label
                        className="form-check-label select-none"
                        htmlFor="class"
                      >
                        Class
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <p>{notificationFor === "section" ? true : false}</p>
                      <input
                        name="form-check-group-image"
                        className="form-check-input"
                        type="radio"
                        value=""
                        checked={notificationFor === "section"}
                        id="section"
                        onChange={NotificationForRadioChange}
                      />
                      <label
                        className="form-check-label select-none"
                        htmlFor="section"
                      >
                        Section
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input
                        name="form-check-group-image"
                        className="form-check-input"
                        type="radio"
                        value=""
                        checked={notificationFor === "student"}
                        id="student"
                        onChange={NotificationForRadioChange}
                      />
                      <label
                        className="form-check-label select-none"
                        htmlFor="student"
                      >
                        Student
                      </label>
                    </div>
                    {localStorage.usertype !== "teacher" && (
                      <>
                        <div className="form-check form-check-inline">
                          <input
                            name="form-check-group-image"
                            className="form-check-input"
                            type="radio"
                            value=""
                            checked={notificationFor === "teacher"}
                            id="teacher"
                            onChange={NotificationForRadioChange}
                          />
                          <label
                            className="form-check-label select-none"
                            htmlFor="teacher"
                          >
                            Teacher
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            name="form-check-group-image"
                            className="form-check-input"
                            type="radio"
                            value=""
                            checked={notificationFor === "course"}
                            id="course"
                            onChange={NotificationForRadioChange}
                          />
                          <label
                            className="form-check-label select-none"
                            htmlFor="course"
                          >
                            Course
                          </label>
                        </div>
                      </>
                    )}
                  </div>
                  <div className="col mt-2">
                    {/* class field if notification_for section */}
                    {(notificationFor === "section" ||
                      notificationFor === "class") && (
                      <div className="form-floating form-floating-outline mb-4">
                        <select
                          className="form-select"
                          name="classid"
                          id="classid"
                          aria-label="Select Class"
                          value={selectedClassnm}
                          onChange={handleSelectedClass}
                        >
                          <option
                            value=""
                            disabled
                            selected
                            className="text-center"
                          >
                            Select Class
                          </option>
                          {classnm.map((cls) => (
                            <option key={cls.classid} value={cls.classid}>
                              {cls.class}
                            </option>
                          ))}
                        </select>
                        <label htmlFor="classid">Class</label>
                      </div>
                    )}

                    {/* input field for notification_for */}
                    {notificationFor !== "class" && (
                      <div className="form-floating form-floating-outline mb-4">
                        <select
                          className="form-select"
                          name="classid"
                          id="classid"
                          aria-label="Select Class"
                          value={selectedOption}
                          onChange={handleSelectedNotificationForOption}
                        >
                          <option
                            value=""
                            disabled
                            selected
                            className="text-center"
                          >
                            Select{" "}
                            {notificationFor === "section"
                              ? "Section"
                              : notificationFor === "teacher"
                              ? "Teacher"
                              : notificationFor === "student"
                              ? "Student"
                              : notificationFor === "course"
                              ? "Course"
                              : ""}
                          </option>
                          {
                            //section option
                            notificationFor === "section"
                              ? section.map((sec) => (
                                  <option value={sec.sectionid}>
                                    {sec.section}
                                  </option>
                                ))
                              : //teacher option
                              notificationFor === "teacher"
                              ? teachers.map((tcr) => (
                                  <option value={tcr.tid}>
                                    {tcr.fname} {tcr.lname}
                                  </option>
                                ))
                              : //student option
                              notificationFor === "student"
                              ? student.map((std) => (
                                  <option value={std.id}>
                                    {std.first_name} {std.last_name}
                                  </option>
                                ))
                              : //course option
                              notificationFor === "course"
                              ? course.map((crs) => (
                                  <option value={crs.course_id}>
                                    {crs.course_name}
                                  </option>
                                ))
                              : ""
                          }
                        </select>
                        <label htmlFor="classid">
                          {notificationFor === "section"
                            ? "Section"
                            : notificationFor === "teacher"
                            ? "Teacher"
                            : notificationFor === "student"
                            ? "Student"
                            : notificationFor === "course"
                            ? "Course"
                            : ""}
                        </label>
                      </div>
                    )}
                  </div>

                  {/* submit btn*/}
                  <div className="mt-3 justify-content-end">
                    <div className="col-sm-10">
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={createNotification}
                      >
                        {id ? "Update" : "Submit"}
                      </button>
                      {/* clear | calcel */}
                      <button
                        type="button"
                        className="btn ml-2 btn-secondary"
                        onClick={clearForm}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </>
              )}
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddNotification;
